export default {"src":"/_next/static/media/aione.dbc16cea.svg","height":55,"width":52};